import { render, staticRenderFns } from "./teachingMain.vue?vue&type=template&id=d2241432&scoped=true"
import script from "./teachingMain.vue?vue&type=script&lang=ts"
export * from "./teachingMain.vue?vue&type=script&lang=ts"
import style0 from "./teachingMain.vue?vue&type=style&index=0&id=d2241432&prod&lang=scss&scoped=true"
import style1 from "./teachingMain.vue?vue&type=style&index=1&id=d2241432&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2241432",
  null
  
)

export default component.exports